/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConsultantViewModel } from './ConsultantViewModel';
import {
    ConsultantViewModelFromJSON,
    ConsultantViewModelFromJSONTyped,
    ConsultantViewModelToJSON,
} from './ConsultantViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfConsultantViewModel
 */
export interface ResultOfConsultantViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfConsultantViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfConsultantViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfConsultantViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfConsultantViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfConsultantViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfConsultantViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfConsultantViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {ConsultantViewModel}
     * @memberof ResultOfConsultantViewModel
     */
    data?: ConsultantViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfConsultantViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfConsultantViewModel interface.
 */
export function instanceOfResultOfConsultantViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfConsultantViewModelFromJSON(json: any): ResultOfConsultantViewModel {
    return ResultOfConsultantViewModelFromJSONTyped(json, false);
}

export function ResultOfConsultantViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfConsultantViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ConsultantViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfConsultantViewModelToJSON(value?: ResultOfConsultantViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': ConsultantViewModelToJSON(value.data),
        'Count': value.count,
    };
}

